export default {
  generic_error: 'Algo correu mal',
  address_not_found:
    'Lamentamos, não foi possível encontrar esse endereço. Tente novamente introduzindo primeiro a rua no campo de pesquisa de endereço.',
  internal_error:
    'Infelizmente, ocorreu um problema inesperado com o seu pedido, a nossa equipa técnica já está a trabalhar nisso 🛠️.',
};
